import { render, staticRenderFns } from "./yexiang.vue?vue&type=template&id=06c0a2a1&scoped=true"
import script from "./yexiang.vue?vue&type=script&lang=js"
export * from "./yexiang.vue?vue&type=script&lang=js"
import style0 from "./yexiang.vue?vue&type=style&index=0&id=06c0a2a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c0a2a1",
  null
  
)

export default component.exports